module.exports = __webpack_public_path__ + "static/img/05006A_2_R_20200401_LC.81f8ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05006A_2_R_20200401_LC.png
// module id = bYEf
// module chunks = 0